import React from 'react';
import SecuredFooter from './SecuredFooter';

/**
 * The single centered card every hosted screen renders in (Figma: 464px white
 * card on #f4f6f9). Collapses to a full-width single column on mobile.
 */
const CardShell = ({ children }) => (
	<div className="flex min-h-screen justify-center bg-[#f4f6f9] px-[16px] py-[48px]">
		<div className="flex h-fit w-full max-w-[464px] flex-col gap-[18px] rounded-[22px] bg-white p-[32px] shadow-[0px_8px_28px_0px_rgba(5,46,102,0.1)]">
			{children}
			<SecuredFooter />
		</div>
	</div>
);

export default CardShell;
